module.exports = __webpack_public_path__ + "img/aMnkyJump_350x350.54953255.jpg";